import axios from "axios";
const base_api = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: base_api,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const getData = (endpoint, params = {}, config = {}) => {
  return api.get(endpoint, { params, ...config });
};

export const postData = (endpoint, data = {}, useFormData = false) => {
  const config = useFormData
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : {};
  return api.post(endpoint, data, config);
};

export const putDataWithMethodOverride = (endpoint, id = '', data = {}, useFormData = false) => {
  const config = useFormData
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : {};
  const url = id ? `${endpoint}/${id}?_method=PUT` : `${endpoint}?_method=PUT`;
  return api.post(url, data, config);
};

export const putData = (endpoint, id = '', data = {}, useFormData = false) => {
  const config = useFormData
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : {};
  const url = id ? `${endpoint}/${id}` : endpoint;
  return api.put(url, data, config);
};

export const putRequet = (endpoint, id, data = {}, useFormData = false) => {
  const config = useFormData
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : {};
  const url = `${endpoint}/${id}`;
  return api.put(url, data, config);
};

export const deleteData = (endpoint, params = {}) => {
  return api.delete(endpoint, { params });
};

export const searchProducts = (query) => {
  return api.get('/product/search', { params: { query } });
};

export default api;